import { createContext } from "react";

const ModulosContext = createContext();

export default ModulosContext;
